import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Spinner from '../layout/Spinner';
import { logout } from '../../actions/auth';
import { Redirect } from 'react-router-dom';
import EventoWhrebyElement from '../eventi/EventoWhrebyElement';
import { useParams } from 'react-router-dom';

const EventoAgenda = ({ auth: { user, loading }, alert, logout }) => {

  let { roomName, roomKey } = useParams();



  if (!user) {
    //return <Redirect to="/gestione-portale" />;
  }

    return (loading ? <Spinner /> :
      <section className="fd-section wide">
        <div className="w-layout-blockcontainer fd-container w-container">
          <div className="fd-wrap">
            <div className="header">
              <a href="/" className="brand w-nav-brand">
              <img src="/assets/media/fondazione_danesino_logo.svg" sizes="(max-width: 479px) 170px, (max-width: 767px) 33vw, 170px" srcset="" alt="" className="image logo logo-fondazione" data-savepage-loading="lazy" />
              <img src="/assets/media/noi_con_voi-fondazione_danesino-logo--oriz.png" sizes="(max-width: 479px) 170px, (max-width: 767px) 33vw, 170px" srcset="" alt="" className="image logo" data-savepage-loading="lazy" />
              </a>
              <div className='nome'>
              <div>Ciao <strong className='nome-utente'>{user && user.username} </strong> 
              {user && user.ruolo == 'admin' ? <a href="" className="link" onClick={() => logout()}>Clicca qui per uscire</a> : '' }
              </div>
          </div>
        </div>
      </div>
    </div>
    <div className="w-layout-blockcontainer fd-container w-container evento-aperto">
      <div className="fd-wrap">
        <div className="w100">
        <div className="">
            <EventoWhrebyElement roomName={roomName} roomKey={roomKey} roomUrl={`https://22-am.whereby.com/${roomName}${user && user.ruolo == 'admin' ? "?roomKey=" + roomKey : ""}`}/>
            </div>
        </div>
      </div>
    </div>
  </section> 
    )
};

EventoAgenda.propTypes = {
  auth: PropTypes.object.isRequired,
  alert: PropTypes.object.isRequired,
  logout: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    auth: state.auth,
    alert: state.alert
});

export default connect(mapStateToProps, {logout})(EventoAgenda);